import { BaseEdge, getStraightPath, getBezierPath } from '@xyflow/react';
import type { EdgeProps } from '@xyflow/react';

export function TreeEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
}: EdgeProps) {
  let edgePath: string;

  if (Math.abs(sourceX - targetX) < 10) {
    [edgePath] = getStraightPath({ sourceX, sourceY, targetX, targetY });
  } else {
    [edgePath] = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
      curvature: 0.35,
    });
  }

  return <BaseEdge id={id} path={edgePath} style={style} />;
}
